<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    :class="[
      'inline-flex items-center justify-center gap-2 font-medium whitespace-nowrap transition-colors',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      sizeClasses,
      variantClasses,
    ]"
  >
    <Loader2 v-if="loading" :size="iconSize" class="animate-spin" />
    <component :is="leftIcon" v-else-if="leftIcon" :size="iconSize" />
    <span v-if="$slots.default"><slot /></span>
    <component :is="rightIcon" v-if="rightIcon && !loading" :size="iconSize" />
  </button>
</template>

<script setup>
import { computed } from 'vue';
import { Loader2 } from 'lucide-vue-next';

const props = defineProps({
  variant:   { type: String, default: 'secondary' }, // primary | secondary | ghost | danger | warning
  size:      { type: String, default: 'md' },        // sm | md | lg
  type:      { type: String, default: 'button' },
  disabled:  { type: Boolean, default: false },
  loading:   { type: Boolean, default: false },
  leftIcon:  { type: [Object, Function], default: null },
  rightIcon: { type: [Object, Function], default: null },
});

const sizeClasses = computed(() => ({
  sm: 'text-xs px-2.5 py-1.5 rounded-[var(--radius-md)]',
  md: 'text-sm px-3 py-2 rounded-[var(--radius-md)]',
  lg: 'text-sm px-4 py-2.5 rounded-[var(--radius-md)] font-semibold',
}[props.size]));

const iconSize = computed(() => ({ sm: 14, md: 15, lg: 16 }[props.size]));

const variantClasses = computed(() => ({
  primary:   'bg-lime text-black border border-lime hover:bg-lime-dim font-semibold',
  secondary: 'bg-bg-1 text-text-2 border border-line-2 hover:bg-bg-2 hover:text-text',
  ghost:     'bg-transparent text-text-2 border border-transparent hover:bg-bg-2 hover:text-text',
  danger:    'bg-transparent text-err border border-line-2 hover:bg-[rgba(240,82,82,0.08)] hover:border-err',
  warning:   'bg-transparent text-warn border border-line-2 hover:bg-[rgba(245,165,36,0.08)] hover:border-warn',
}[props.variant]));
</script>
